const createBroadcastChannel = () => {
  const bc = new BroadcastChannel('IsvBroadcastChannel');
  return bc;
};

export const broadcastMessage = (message) => {
  const bc = createBroadcastChannel();
  return bc.postMessage(message);
};
